import React from 'react';
import styles from './InnovatorSimple.module.css';
import { useNavigate } from 'react-router-dom';

export default function InnovatorSimple() {
  const navigate = useNavigate();

  return (
    <div className={styles.innovatorContainer}>
      <h1 className={styles.innovatorTitle}>ChronoTech Innovator Program</h1>
      <p className={styles.innovatorDescription}>
        Pilot 2025 – An intensive program designed for motivated students, hobbyists, and aspiring inventors. 
        Transform your ideas into reality by working with professional-grade components, developing creative 
        prototypes, and gaining exclusive early access to cutting-edge ChronoTech tools and methodologies.
      </p>

      <section className={styles.highlightSection}>
        <h2>Program Highlights</h2>
        <ul className={styles.highlightList}>
          <li>Master design thinking and rapid prototyping</li>
          <li>Build open-ended hardware projects using real kits</li>
          <li>Present your ideas in professional demos</li>
          <li>Network with peers and industry mentors</li>
          <li>Get personal coaching from product developers</li>
          <li>Exclusive early access to ChronoTech tools</li>
        </ul>
      </section>

      <section className={styles.phaseSection}>
        <h2>Phase 1: Ideation & Strategic Planning</h2>
        <div className={styles.phaseRow}>
          <img src="/images/placeholder1.png" alt="Ideation phase" />
          <div>
            <p>
              Every great innovation starts with a compelling problem worth solving. In this phase, you'll explore
              design thinking, research strategies, and idea validation to define and scope a unique solution.
            </p>
          </div>
        </div>
      </section>

      <section className={styles.phaseSection}>
        <h2>Phase 2: Prototyping & Testing</h2>
        <div className={styles.phaseRow}>
          <img src="/images/placeholder2.png" alt="Prototyping phase" />
          <div>
            <p>
              Use Arduino, ESP32, Raspberry Pi, sensors, and motors to turn your concept into a functioning prototype.
              Test, iterate, and optimize under expert guidance while documenting your progress.
            </p>
          </div>
        </div>
      </section>

      <section className={styles.phaseSection}>
        <h2>Phase 3: Product Development</h2>
        <p>
          Take your prototype to the next level with UX design, technical documentation, and launch presentation prep.
          Learn to think like a real-world product engineer.
        </p>
      </section>

      <section className={styles.phaseSection}>
        <h2>Phase 4: Business Strategy</h2>
        <p>
          Explore how real products succeed. Learn about market research, branding, pricing models, and how to pitch
          ideas to investors or schools.
        </p>
      </section>

      <section className={styles.phaseSection}>
        <h2>Phase 5: Finance & Operations</h2>
        <p>
          Understand cost structures, margins, revenue modeling, and basic investment planning. Turn your tech idea into
          a sustainable business.
        </p>
      </section>

      <section className={styles.finalSection}>
        <h2>Ready to Join?</h2>
        <p>
          Applications for our next cohort are now being accepted. Connect with us to learn more about admission
          requirements, program dates, and scholarship opportunities.
        </p>
        <button className={styles.contactButton} onClick={() => navigate('/contact')}>
          Contact Us
        </button>
      </section>
    </div>
  );
}
